export default __webpack_public_path__ + "static/media/weblogo.c98063e7.svg";